(() => {
  const STORAGE_KEY = 'sl-newsletter-scroll-target';

  const restoreScrollPosition = () => {
    const targetId = sessionStorage.getItem(STORAGE_KEY);

    if (!targetId) return;

    const target = document.querySelector(`[data-sl-newsletter-id="${targetId}"]`);

    if (!target) {
      sessionStorage.removeItem(STORAGE_KEY);
      return;
    }

    const top = window.scrollY + target.getBoundingClientRect().top - 24;

    const scrollToTarget = () => {
      window.scrollTo({ top: Math.max(0, top), left: 0, behavior: 'auto' });
    };

    scrollToTarget();
    window.setTimeout(scrollToTarget, 120);
    window.setTimeout(() => {
      scrollToTarget();
      sessionStorage.removeItem(STORAGE_KEY);
    }, 280);
  };

  const bindNewsletterForms = (root = document) => {
    root.querySelectorAll('[data-sl-newsletter-signup]').forEach((section) => {
      if (section.dataset.slNewsletterBound === 'true') return;

      const form = section.querySelector('form[action*="/contact"]');
      if (!form) return;

      section.dataset.slNewsletterBound = 'true';

      form.addEventListener('submit', () => {
        const id = section.getAttribute('data-sl-newsletter-id');
        if (!id) return;

        sessionStorage.setItem(STORAGE_KEY, id);
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    bindNewsletterForms();
  });

  window.addEventListener('load', restoreScrollPosition);

  document.addEventListener('shopify:section:load', (event) => {
    bindNewsletterForms(event.target);
  });
})();
